import { STORAGE_KEYS } from '@constants/index';

export const readNavCollapsed = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED) === 'true';
  } catch {
    return false;
  }
};

export const writeNavCollapsed = (collapsed: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(collapsed));
  } catch {
    // Storage is blocked: the choice lasts for this visit only.
  }
};
